export default [
  {
    path: 'order/set',
    name: '基础设置',
    component: () => import (`@/views/sys/set/index.vue`),
  },
  {
    path: 'sys/manage',
    name: '调度管理',
    component: () => import (`@/views/sys/user/index.vue`),
  }
];
